export const equityRows = [
  { name: '每日免费积分', key: 'dailyFreeIntegral', kind: 'integral' },
  { name: '模板权限', key: 'templatePermission', kind: 'text' },
  { name: '生成PPT能力', key: 'pptFreeGen', kind: 'quota' },
  { name: 'PPT下载/导出', key: 'pptExport', kind: 'text' },
  { name: '无水印下载', key: 'watermarkFreeDownload', kind: 'text' },
  { name: 'AI润色/改写', key: 'aiPolishRewrite', kind: 'boolean' },
  { name: '云端存储策略', key: 'cloudStorageStrategy', kind: 'text' },
  { name: '极速生成通道', key: 'generationChannel', kind: 'channel' },
  { name: '会员限时好礼', key: 'thirdPartySharedVip', kind: 'boolean' },
  { name: 'PPT限时模板', key: 'pptLimitedTemplate', kind: 'boolean' },
  { name: '团队会员', key: 'teamShare', kind: 'count' },
  { name: '额外赠送会员有效期', key: 'extraVipDuration', kind: 'text' },
]

function textCell(text) {
  return {
    type: 'text',
    text
  }
}

function iconCell(checked) {
  return {
    type: 'icon',
    checked
  }
}

function isEmptyObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0
}

function formatQuotaCell(value) {
  if (!value || isEmptyObject(value)) return iconCell(false)
  if (value.type === 'UNLIMITED') return textCell('无限制')
  if (value.type !== 'CUSTOM' || !value.count || value.count <= 0) return iconCell(false)

  return textCell(`${value.count}次/天`)
}

function formatChannelCell(value) {
  const channelMap = {
    PRIORITY_QUEUE: '优先队列',
    FAST_CHANNEL: '高速通道',
    VIP_FAST_CHANNEL: 'VIP极速通道'
  }
  if (!value) return iconCell(false)
  return textCell(channelMap[value] || value)
}

function formatCountCell(value) {
  if (!value || isEmptyObject(value)) return iconCell(false)
  const count = Number(value.subAccountCount || 0)
  return count > 0 ? textCell(`+${count}个子账号`) : iconCell(false)
}

function formatTextCell(value) {
  if (value === undefined || value === null || value === '') return iconCell(false)
  return textCell(String(value))
}

function formatEquityCell(equityConfig, row) {
  const value = equityConfig[row.key]
  if (row.kind === 'quota') return formatQuotaCell(value)
  if (row.kind === 'boolean') return iconCell(value === true)
  if (row.kind === 'integral') return value > 0 ? textCell(`${value}积分`) : iconCell(false)
  if (row.kind === 'hours') return value > 0 ? textCell(`${value}小时`) : iconCell(false)
  if (row.kind === 'channel') return formatChannelCell(value)
  if (row.kind === 'count') return formatCountCell(value)
  if (row.kind === 'text') return formatTextCell(value)
  return iconCell(false)
}

function shouldShowPptNoDownloadText(row, column, cell) {
  const hasQuotaCountText = cell.type === 'text' && (cell.text === '无限制' || /\d/.test(String(cell.text || '')))
  return row.key === 'pptFreeGen' && column.catalog?.type === 'NORMAL' && hasQuotaCountText
}

export function buildRightsCompare(columns, rows = equityRows) {
  return rows.map((row) => ({
    name: row.name,
    cells: columns.map((column) => {
      const cell = formatEquityCell(column.catalog?.equityConfig || {}, row)
      return {
        key: column.key,
        ...cell,
        ...(shouldShowPptNoDownloadText(row, column, cell) ? { subText: '（不含下载）' } : {})
      }
    })
  }))
}
